import React, { useEffect, useRef, useState, useCallback } from "react";
import Vimeo from '@vimeo/player';

type Props = {
    videoId: number,
    autoplay?: boolean,
    onTimeUpdate?: (time: number) => void
}

enum PLAYER_STATE {
    LOADING,
    PLAYING,
    PAUSED,
    ERROR,
    ENDED
}

const VimeoPlayer: React.FunctionComponent<Props> = ({ videoId, autoplay = false, onTimeUpdate = () => {} }) => {

    // const embed = `<iframe src="https://player.vimeo.com/video/428955700" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
    // const player

    const player = useRef<Vimeo>();

    const [playerState, setPlayerState] = useState<PLAYER_STATE>(PLAYER_STATE.LOADING);

    const showLoader = playerState === PLAYER_STATE.LOADING;

    const showPlayerAPI =
        showLoader ||
        playerState === PLAYER_STATE.PAUSED ||
        playerState === PLAYER_STATE.LOADING;


    useEffect(() => {

        if (!player.current) {
            player.current = new Vimeo('vimeo-player', {
                id: videoId,
                width: 715,
                portrait: false,
                title: false,
                byline: false,
                autoplay,
                controls: false,
                loop: false,
                responsive: true,
                muted: true
            })

            player.current.on('playing', () => {
                console.log('PLAYING')
                setPlayerState(PLAYER_STATE.PLAYING);
            })

            player.current.on('loaded', () => {
                console.log('loaded')
                setPlayerState(autoplay ? PLAYER_STATE.LOADING : PLAYER_STATE.PAUSED);
            })

            player.current.on('pause', () => {
                console.log('PAUSED')
                setPlayerState(PLAYER_STATE.PAUSED);
            })

            player.current.on('timeupdate', ({dutarion, percent, seconds}) => {
                onTimeUpdate(seconds)
            })

        } else {
            setPlayerState(PLAYER_STATE.LOADING);
            player.current.loadVideo(videoId);
        }

    }, [videoId, autoplay, onTimeUpdate])

    const onAPIClick = useCallback(() => {
        if (player.current) {

            switch(playerState) {
                case PLAYER_STATE.PLAYING:
                    player.current.pause();
                    break;

                case PLAYER_STATE.PAUSED:
                    player.current.play();
                    break;
            }
        }
    }, [playerState])

    return (
        <>
            <div id="vimeo-player" style={{ position: "relative", width: '715px', maxWidth: '100%' }}>
                {<div className="customApi" style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    cursor: 'pointer',
                    background: showLoader ? `url(${process.env.PUBLIC_URL}/images/loader.gif) 50% 50% no-repeat rgba(0,0,0,.5)` : (showPlayerAPI ? `url(${process.env.PUBLIC_URL}/images/play.png) 50% 50% no-repeat rgba(0,0,0,.5)` : 'none'),
                    zIndex: 1
                }} onClick={onAPIClick}>
                </div>}
            </div>
        </>
    )
}

export default VimeoPlayer;
